import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Banner() {
  return (
      <section className="kushme_banner">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
              <h1 style={{ color: "#fff" }}>Kush Me mobile app development</h1>
              <p style={{ color: "#fff" }}>
                Your pal for recreational marijuana runs – Kush Me delivers
                marijuana to your doorstep.
              </p>
            </Col>
            <Col
                xs={12}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className="offset-lg-1  text-center my-auto"
            >
              <StaticImage
                  src="../../../images/case-studies/kush-me/banner_img.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={440}
                  height={500}
              />
            </Col>
          </Row>
        </Container>
      </section>
  );
}

export default Banner;
